import {
  EncounterSignOff,
  EncounterSummaryControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useEncounterSignOff = () =>
  useMutationWithLoading(
    async (params: {
      encounterSummaryId: string;
      encounterSignOff: EncounterSignOff;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).signOffEncounterSummary(
        params.encounterSummaryId,
        params?.encounterSignOff,
        params?.xTENANTID
      )
  );
